// Forwards Livewire-dispatched browser events onto GA4's gtag() as standard
// enhanced-ecommerce events. No-ops if GA4 isn't configured (gtag undefined) -
// mirrors how the rest of the storefront tolerates optional tracking IDs.
function ga4(eventName, params) {
    if (typeof gtag !== 'function') {
        return;
    }

    gtag('event', eventName, params);
}

window.addEventListener('ga4-view-item', (event) => {
    ga4('view_item', {
        currency: 'ZAR',
        value: event.detail.price,
        items: [{
            item_id: event.detail.item_id,
            item_name: event.detail.item_name,
            price: event.detail.price,
            quantity: event.detail.quantity,
        }],
    });
});

window.addEventListener('ga4-add-to-cart', (event) => {
    ga4('add_to_cart', {
        currency: 'ZAR',
        value: event.detail.price * event.detail.quantity,
        items: [{
            item_id: event.detail.item_id,
            item_name: event.detail.item_name,
            price: event.detail.price,
            quantity: event.detail.quantity,
        }],
    });
});

window.addEventListener('ga4-begin-checkout', (event) => {
    ga4('begin_checkout', {
        currency: 'ZAR',
        value: event.detail.value,
        items: event.detail.items.map((item) => ({
            item_id: item.item_id,
            price: item.price,
            quantity: item.quantity,
        })),
    });
});
